import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SiteService } from '@app/app-state/site.service';
import { ChartDataService } from '@app/backend/chart-data.service';
import { GraphReportComponent } from '@app/gui/report/graph-report/graph-report.component';
import { FielderDataset } from '@app/models/chart-data.model';
import { MatDialog } from '@angular/material/dialog';
import { UtilizationTableViewComponent } from './utilization-table-view/utilization-table-view.component';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-fielder-dashboard',
	templateUrl: './fielder-dashboard.component.html',
	styleUrls: ['./fielder-dashboard.component.scss'],
	standalone: false
})
export class FielderDashboardComponent implements OnInit {
	@Input() siteId:number;
	@Input() domainId:number;
	@ViewChild('utilizationTableView') utilizationTableRef!: UtilizationTableViewComponent;

	public drillingDataOptions: FielderDataset[] | null = null;
	public selectedDrillingId: string;
	public drillingControl =  new FormControl<FielderDataset>(null);
	public subdomainId:number;
	private selectedTab: string = 'Fielder Analytics';
	public activeTabTitle: string = 'Fielder Analytics';
	public activeTabDescription: string ;
	public drillDropdownOpen = false;
	private subscriptions: Subscription = new Subscription();
	@HostListener('document:click', ['$event'])
	onOutsideClick(event: Event): void {
	const clickedInside = (event.target as HTMLElement).closest('.custom-dropdown');
		if (!clickedInside) {
			this.drillDropdownOpen = false;
		}
	}

	constructor(
		private readonly siteService: SiteService,
		private readonly chartDataService: ChartDataService,
		private dialog: MatDialog,
	) {
	}

	ngOnInit(): void {
		this.subscriptions.add(this.siteService.domainId$.subscribe(domainId=> {
			if (domainId) {
				this.chartDataService.getDrillMachines(domainId);
			}
		}));

		this.subscriptions.add(this.chartDataService.allFielderDataset$.subscribe((drillingData) => {
			this.drillingDataOptions = drillingData;
			if(drillingData == null) {
				this.drillingControl.setValue(null);
			}
		}));;

		this.chartDataService.selectedTab$.next(this.selectedTab);
	}

	public ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	public displayDrillingName(drillingObj: FielderDataset): string {
		return drillingObj && drillingObj.name ? drillingObj.name : '';
	}
	public toggleDrillDropdown(): void {
		this.drillDropdownOpen = !this.drillDropdownOpen;
	}

	public clearDrillSelection(event: MouseEvent): void {
		event.stopPropagation();
		this.drillingControl.setValue(null);
		this.selectedDrillingId = null;
		this.siteService.selectedDrillMachine$.next(null);
		this.drillDropdownOpen = false;
	}

	public onDrillOptionSelected(option: FielderDataset, event: MouseEvent): void {
		event.stopPropagation();
		this.drillingControl.setValue(option);
		this.selectedDrillingId = option?.uuid;
		this.siteService.selectedDrillMachine$.next(this.selectedDrillingId);
		this.drillDropdownOpen = false;
	}

	public onSequenceChangeEvent(ev) {
		this.chartDataService.selectedTab$.next(ev.tab?.textLabel);
			const tabLabel = ev.tab?.textLabel;

			const tabMap: { [key: string]: { title: string, description: string } } = {
				'Fielder Analytics': {
					title: 'Drill Analytics',
					description: 'visualizes Total drilled holes, length & time, Average time between holes, time per hole & drilled holes per day'
				},
				'Holes & Drilled Holes': {
					title: 'Drill Analytics Holes',
					description: 'visualizes Total holes & Total drilled holes'
				},
				'Drilled Holes by Drilled Length': {
					title: 'Drill Analytics by Length',
					description: 'visualizes Total drilled length & Total drilled holes'
				},
				'Utilization on Shot': {
					title: 'Utilization on Shot',
					description: 'visualizes Total drilled; holes, length & time by Drill machine names'
				},
				'Fielder Analytics by Drill': {
					title: 'Fielder Analytics by Drill',
					description: 'visualizes analytics per drill unit'
				},
				'Utilization Table View': {
					title: 'Utilization Table View',
					description: 'visualizes'
				}
			};

			const selectedTab = tabMap[tabLabel];
			this.activeTabTitle = selectedTab?.title || 'Fielder Analytics';
			this.activeTabDescription = selectedTab?.description || 'visualizes Total drilled holes, length & time, Average time between holes, time per hole & drilled holes per day';

			this.chartDataService.selectedTab$.next(tabLabel);
		}

	public pdfDownload() {
		this.dialog.open(GraphReportComponent, {
			width: '100vw',
			height: '100vh',
			maxWidth: '100vw',
			panelClass: 'full-screen-dialog',
			disableClose: true
		});
	}
}
